import {ProgressiveGlobalLoading} from '@fe-progressive/package-progressive/progressive-loading';
import React from 'react';

const DialogLoading = (props: {isVisible: boolean}) => {
  return <ProgressiveGlobalLoading visible={props.isVisible} />;
};
export default DialogLoading;
